import { VueRenderer } from '@tiptap/vue-3'
import tippy from 'tippy.js'
import ActorUserMentionList from '../components/TextArea/ActorUserMentionList.vue'
import { getSearchResultsForQueryType } from '../api/general-search.js'
import { fetchUsersToMention } from '../api/notifications.js'
import { mapNewGlobalSearchResultToLegacyFormat } from '@/util/helpers.js'

export default {
  items: async ({ query }) => {
    if (query.length < 2) {
      return { query, data: [], message: 'At least 2 characters are required' }
    }

    let results = []

    await getSearchResultsForQueryType({query, type: 'actors'})
      .then(result => {
        results = mapNewGlobalSearchResultToLegacyFormat([...result.actors, ...result.products])
      })
      .catch(error => {
        console.log(error)
      })

    // When relevant, retrieve the community id, so that only users that are member of the community can be mentionned
    // NOTE: ideally, the communityId can be fetched via the route parameters, although
    const dataCommunityElement = document.getElementById('data-community-id')
    const communityId = dataCommunityElement ? dataCommunityElement.textContent : null;

    // Fetch the users
    let users = []
    await fetchUsersToMention({query:query, verified: true, communityId: communityId}).then((response) => {
      users = response.data
    })

    users.forEach(user => {
      const userObject = {
        name: user.name,
        value: user.id,
        type: 'user'
      }
      if (!results.includes(userObject)) {
        results.push(userObject)
      }
    })

    // Only display the first 5 results
    const slicedResult = (results || [])//.slice(0, 5)

    return {
      query,
      data: slicedResult,
      message: ''
    }
  },
  render: () => {
    let component
    let popup

    return {
      onStart: props => {
        component = new VueRenderer(ActorUserMentionList, {
          props,
          editor: props.editor,
        })

        popup = tippy('body', {
          getReferenceClientRect: props.clientRect,
          appendTo: () => document.body,
          content: component.element,
          showOnCreate: true,
          interactive: true,
          trigger: 'manual',
          placement: 'right-end', // "top-start" | "top-end" | "bottom-start" | "bottom-end" | "right-start" | "right-end" | "left-start" | "left-end"
        })
      },

      onUpdate (props) {
        component.updateProps(props)

        popup[0].setProps({
          getReferenceClientRect: props.clientRect,
        })
      },

      onKeyDown (props) {
        if (props.event.key === 'Escape') {
          popup[0].hide()

          return true
        }

        return component.ref?.onKeyDown(props)
      },

      onExit () {
        popup[0].destroy()
        component.destroy()
      },
    }
  },
  command: ({ editor, range, props }) => {
    range.to += 1

    let content = `<a href="${window.location.protocol}//${window.location.hostname}/actors/${props.id}" target="_self">${props.label}</a> `

    if (props.type && props.type === 'user') {
      content = `<a href="${window.location.protocol}//${window.location.hostname}/profile/conversations" class="data-mention-type--user" rel="${props.id}" target="_self">${props.label}</a> `
    }

    editor
      .chain()
      .focus()
      .insertContentAt(range, content)
      .run()
  },
}
